import mediator from '../utilities/mediator';
import log from '../utilities/log';
import { ApiErrorResponse, Role } from '../models';
import { queryOptions, UseQueryOptions } from '@tanstack/react-query';
import { EntityState, EntityType } from 'adc-sirius-module-common';

type RolesQueryParams = {
  entityType?: EntityType;
  rowState?: EntityState;
};

export function rolesQueryOptions(
  params: RolesQueryParams = {},
  options?: Partial<UseQueryOptions<Role[]>>,
) {
  return queryOptions<Role[]>({
    ...options,
    queryKey: ['roles', params],
    queryFn: async () => {
      try {
        return await mediator.request<Role[]>('role:getRoles', {
          entityType: params.entityType,
          rowState: params.rowState,
        });
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
  });
}
